const startCaseFilter = () => {
  return (string) => {
    return _.startCase(string);
  }
};

export default {
  startCaseFilter
};



// WEBPACK FOOTER //
// ./src/filters/stringFilters.js